import { useRepositoryInfiniteQuery } from '@mews-commander/data-access';

const PAGE_SIZE = 10;

export const useSearchCustomersQuery = (searchToken: string) =>
    useRepositoryInfiniteQuery(
        'customers',
        'search',
        ({ pageParam }) => ({
            searchToken,
            startIndex: pageParam,
            count: PAGE_SIZE,
        }),
        {
            enabled: !!searchToken,
            initialPageParam: 0,
            getNextPageParam: (lastPage, allPages) =>
                lastPage.length < PAGE_SIZE ? undefined : allPages.length * PAGE_SIZE,
            select: (queryData) => queryData.pages.flat(),
        }
    );
